export default __webpack_public_path__ + "static/media/lettre.15d4230e.png";